export default __webpack_public_path__ + "static/media/music-card-bg.b0d2b21b.svg";